import { Colors } from "../../assets/Colors";
import React from "react";

export function GetTh(name, colSpan) {
  return (
    <th
      style={{ color: Colors.primary }}
      colSpan={colSpan}
      className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
    >
      {name}
    </th>
  );
}

export function GetBody(value, arah, colspan) {
  if (arah) {
    return (
      <td
        className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 pt-2 pb-2 text-right"
        colSpan={colspan}
      >
        {value.toLocaleString()}
      </td>
    );
  } else {
    return (
      <td
        className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 pt-2 pb-2 text-left"
        colSpan={colspan}
      >
        {value}
      </td>
    );
  }
}
